import { ID_CARD_REG } from './validator'
import { A_YEAR, BROWSER_SUPPORT_STATUS, SUPPORTED_BROWSER } from './constant'

export const sleep = seconds => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, seconds * 1000)
  })
}

export const idCardNoParse = cardNo => {
  const date = cardNo.replace(ID_CARD_REG, '$1-$2/$3/$4-$5').split('-')[1]
  const birthday = new Date(date).getTime()
  const current = Date.now()
  if (birthday > current || birthday < (current - A_YEAR * 100)) return false
  return date
}

export const base64 = {
  encode: str => window.btoa(str),
  decode: str => window.atob(str)
}

export const getFunctionSupport = async () => {
  if (process.env.NODE_ENV === 'location') return BROWSER_SUPPORT_STATUS.SUPPORT
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    return BROWSER_SUPPORT_STATUS.NOT_SUPPORT
  }

  const devices = await navigator.mediaDevices.enumerateDevices()
  if (!devices || !devices.length) {
    return BROWSER_SUPPORT_STATUS.NOT_SUPPORT
  }

  let audioSupport = false
  let videoSupport = false
  for(let i = 0; i < devices.length; i++) {
    if (devices[i].kind === 'videoinput') videoSupport = true
    if (devices[i].kind === 'audioinput') audioSupport = true
  }
  return (videoSupport && audioSupport) ? BROWSER_SUPPORT_STATUS.SUPPORT : BROWSER_SUPPORT_STATUS.NOT_SUPPORT
}

export const browserIsSupported = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  for (let i in SUPPORTED_BROWSER) {
    if (userAgent.indexOf(SUPPORTED_BROWSER[i]) > -1) {
      return true
    }
  }
  return false
}

export function saveKeyPrefixFormatter (dirs = []) {
  const env = process.env.NODE_ENV === 'production' ? 'prod' : 'local'
  if (!dirs.length) return `/vocational_education/${env}`
  return `/vocational_education/${env}/${dirs.join('/')}`
}
